import {useLocation} from 'react-router-dom';

const useTKRSPage = () => {
  const location = useLocation();

  const pathTokens = location.pathname?.split('/') || [];

  const isCategory = pathTokens?.[1] === 'categories';
  const isSearch = pathTokens?.[1] === 'search';
  const isRecentlyRegistered = pathTokens?.[1] === 'just-added';
  const isPopularGiftsPLP = pathTokens?.[1] === 'popular-gifts';
  const isTrendingPLP = pathTokens?.[1] === 'trending-products';
  const isCollectionPLP = pathTokens?.[1] === 'collections';
  const isInterestPLP = pathTokens?.[1] === 'interests';

  const isPDP = pathTokens?.[1] === 'products';
  const isPLP =
    (['brands', 'categories', 'collections', 'interests', 'stories'].includes(
      pathTokens?.[1],
    ) &&
      pathTokens.length > 2) ||
    isSearch ||
    isTrendingPLP ||
    isRecentlyRegistered ||
    isPopularGiftsPLP;

  return {
    isCategory,
    isCollectionPLP,
    isInterestPLP,
    isPopularGiftsPLP,
    isRecentlyRegistered,
    isPDP,
    isPLP,
    isSearch,
    isTrendingPLP,
    page: pathTokens?.[1],
  };
};

export default useTKRSPage;
